import { Entry } from '@napi-rs/keyring'
const RETOOL_CUSTOM_COMPONENT_LIBRARY_SERVICE_NAME = 'Retool Custom Component Library Service'
const RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME = 'deploy target instance and credentials'
const RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME_FOR_UNIX_SOCKET = 'deploy target unix socket'

export const PASSWORD_DELIMITER = ' '

export type UrlAndAccessToken = {
  url: string
  accessToken: string
  unixSocket: string | undefined
}

export const getTargetUrlAndAccessToken = (instance = 'default'): UrlAndAccessToken | undefined => {
  try {
    const entry = new Entry(
      RETOOL_CUSTOM_COMPONENT_LIBRARY_SERVICE_NAME,
      RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME + instance,
    )
    const password = entry.getPassword()
    if (password) {
      const [url, accessToken] = password.split(PASSWORD_DELIMITER)

      const unixSocketEntry = new Entry(
        RETOOL_CUSTOM_COMPONENT_LIBRARY_SERVICE_NAME,
        RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME_FOR_UNIX_SOCKET + instance,
      )

      const unixSocket = unixSocketEntry.getPassword()
      return {
        url,
        accessToken,
        unixSocket: unixSocket ?? undefined,
      }
    } else {
      return undefined
    }
  } catch (e) {
    throw new Error(
      `Error thrown while trying to load previously used settings. \
@tryretool/custom-component-support uses the @napi-rs/keyring library to store and load credentials and other settings, which uses a different underlying utility depending on your OS. \
See https://github.com/hwchen/keyring-rs?tab=readme-ov-file#platform-specific-issues for help with debugging issues.`, e)
  }

}

export const setTargetUrlAndAccessToken = (args: {
  url: string
  accessToken: string
  instance: string
  unixSocket?: string | undefined
}): void => {
  try {
    const { url, accessToken, unixSocket, instance } = args
    const entry = new Entry(
      RETOOL_CUSTOM_COMPONENT_LIBRARY_SERVICE_NAME,
      RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME + instance,
    )
    entry.setPassword(`${url}${PASSWORD_DELIMITER}${accessToken}`)

    const unixSocketEntry = new Entry(
      RETOOL_CUSTOM_COMPONENT_LIBRARY_SERVICE_NAME,
      RETOOL_CUSTOM_COMPONENT_LIBRARY_ACCOUNT_NAME_FOR_UNIX_SOCKET + instance,
    )
    if (unixSocket) {
      unixSocketEntry.setPassword(unixSocket)
    } else {
      unixSocketEntry.deletePassword()
    }
  } catch (e) {
    throw new Error(
      `Error thrown while trying to write settings. \
@tryretool/custom-component-support uses the @napi-rs/keyring library to store and load credentials and other settings, which uses a different underlying utility depending on your OS. \
See https://github.com/hwchen/keyring-rs?tab=readme-ov-file#platform-specific-issues for help with debugging issues.`, e)
  }
}
